import React, { useEffect, useState } from 'react'
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import SevenNow from '../../public/assets/img/seven-now.svg'
import Divider from '../../public/assets/img/divider.svg'
import { useLocation } from 'react-router-dom';
import MenuIcon from '@mui/icons-material/Menu';
import { useDispatch, useSelector } from 'react-redux';
import { toggleLeftPanel } from '../redux/actions/checkmateAuthorizationAction';
import { capitalizeFirstLetter } from '../shared/utils/format.helpers';
import { appOrganizationSaga } from '../redux/saga/merchantServiceSelectors';
import { MERCHANT_PORTAL_TEXT } from '../constants/buttonConstants';

const Header = () => {
	const stateValue = useLocation();
	const dispatch = useDispatch();
	const [headerText, setHeaderText]= useState(MERCHANT_PORTAL_TEXT);
	const orgName = useSelector(appOrganizationSaga) || sessionStorage.getItem('orgName');
	let leftPanelOpen = true;
	const [pathname, setPathName] = useState('');

	useEffect(()=>{
		if(stateValue && stateValue.pathname) {
		setPathName(stateValue.pathname)
		}
	},[stateValue]);

	useEffect(()=>{
		if(orgName){
		document.title = `${capitalizeFirstLetter(orgName)} Portal`;
		setHeaderText(`${capitalizeFirstLetter(orgName)} Portal`);
		} else {
		document.title = MERCHANT_PORTAL_TEXT;
		setHeaderText(MERCHANT_PORTAL_TEXT);
		}
	},[orgName]);

	const handleHamBurgerClick = () =>{
		leftPanelOpen = !leftPanelOpen;
		dispatch(toggleLeftPanel(leftPanelOpen))
	}

	return (
		<>
		<Box sx={{ flexGrow: 1 }} data-testid='header-merchant-portal'>
			<AppBar style={{ backgroundColor: '#111111' }} position='static'>
			<Toolbar className='merchant' variant='dense'>
				{(pathname.indexOf('dashboard') !== -1) ? <MenuIcon className='merchant--hamburger' onClick={() => handleHamBurgerClick()}/> : null}
				<img src={SevenNow} alt='SevenNow header Logo' />
				<img className='divider' src={Divider} alt='Vertical Divider' />
				<h4 className='merchant--header'>{headerText}</h4>
			</Toolbar>
			</AppBar>
		</Box>
		</>
	)
};

export default Header;
